/**
 * The expand control on a roster row (BON-534).
 *
 * A real `<button>`, a sibling of the row's link rather than nested inside it.
 * `RegionHierarchyTree` nests a `tabIndex={-1}` span-button inside its row
 * button, which is invalid markup and unreachable by keyboard; the Overview
 * criteria require both controls to be operable at every screen size.
 */
export interface ScopeCaretProps {
  open: boolean;
  /** Named so the label reads as an instruction, not as an icon. */
  regionName: string;
  onToggle: () => void;
  /** Tap target. The bottom sheet needs a thumb-sized one; the roster and the
   *  dropdown keep the compact pointer size. */
  width?: number;
  /** The glyph inside it. */
  size?: number;
}

export function ScopeCaret({ open, regionName, onToggle, width = 18, size = 13 }: ScopeCaretProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      aria-label={`${open ? 'Hide' : 'Show'} sub-regions of ${regionName}`}
      style={{
        width,
        height: width,
        flex: `0 0 ${width}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 0,
        borderRadius: 4,
        cursor: 'pointer',
        background: 'transparent',
        color: 'var(--nb-subtle)',
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transform: open ? 'rotate(90deg)' : 'none', transition: 'transform .12s' }}
        aria-hidden="true"
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </button>
  );
}
